import { useState } from "react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

const inputCls =
  "bg-transparent border-b border-[#222222] focus:border-[#FF3B30] outline-none text-white px-0 py-4 text-base transition-colors w-full font-mono-plex placeholder-[#555555]";

export const StaffLogin = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-5">
      <div className="w-full max-w-md border border-[#222222] p-8 md:p-12">
        <span className="text-xs uppercase tracking-[0.2em] text-[#FF3B30] font-mono-plex font-bold">
          [ Staff only ]
        </span>
        <h1 className="font-display font-bold uppercase tracking-tight text-white text-4xl mt-4 leading-[0.9]">
          Employee
          <br />
          Login
        </h1>
        <form onSubmit={submit} className="mt-10 space-y-6">
          <input
            data-testid="staff-login-email"
            type="email"
            required
            placeholder="EMAIL"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
          />
          <input
            data-testid="staff-login-password"
            type="password"
            required
            placeholder="PASSWORD"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
          />
          {error && (
            <p data-testid="staff-login-error" className="text-[#FF3B30] font-mono-plex text-sm">
              {error}
            </p>
          )}
          <button
            data-testid="staff-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#FF3B30] text-white font-mono-plex uppercase tracking-[0.2em] text-sm font-bold py-4 hover:bg-white hover:text-black transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
};
